import { useId } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AnnouncementContent from '@/app/modules/announcements/components/AnnouncementContent';
import AnnouncementModalBand from '@/app/modules/announcements/components/AnnouncementModalBand';
import { publishedLabel } from '@/app/modules/announcements/core/_utils';
import AnnouncementPreviewActions from '@/app/pages/notifications/announcements/components/AnnouncementPreviewActions';
import { useAnnouncementDetails } from '@/app/pages/notifications/announcements/core/_hooks';
import '@/app/modules/announcements/components/AnnouncementModal.scss';

type ViewAnnouncementModalProps = {
  announcementId: string;
  onClose: () => void;
};

/** Quem criou vê o comunicado exatamente como o destinatário, sem registrar visto, ciência ou dispensa. */
const ViewAnnouncementModal = ({ announcementId, onClose }: ViewAnnouncementModalProps) => {
  const titleId = useId();
  const { data: announcement, isPending, isError, refetch } = useAnnouncementDetails(announcementId, true, true);
  const loaded = announcement && !isError ? announcement : undefined;
  // O rascunho ainda não tem quem publicou nem quando; mostra quem criou.
  const senderName = loaded?.published_by_user_name ?? loaded?.created_by_user_name;
  const senderLabel = publishedLabel(senderName, loaded?.published_date);
  const retry = () => {
    void refetch();
  };
  const loadingState = (
    <div className="announcement-modal-content text-center">
      {isPending ? <output>Carregando comunicado…</output> : null}
      {isError ? (
        <div className="alert alert-danger mb-0" role="alert">
          <p>Não foi possível carregar o comunicado.</p>
          <Button variant="light" onClick={retry}>
            Tentar novamente
          </Button>
        </div>
      ) : null}
    </div>
  );

  return (
    <Modal centered show aria-labelledby={titleId} dialogClassName="announcement-modal" onHide={onClose}>
      <AnnouncementModalBand closable closing={false} onClose={onClose} />
      {loaded ? (
        <AnnouncementContent body={loaded.body} senderLabel={senderLabel} title={loaded.title} titleId={titleId}>
          <AnnouncementPreviewActions type={loaded.type.value} onClose={onClose} />
        </AnnouncementContent>
      ) : (
        loadingState
      )}
    </Modal>
  );
};

export default ViewAnnouncementModal;
